<template>
  <div>
    <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          id: this.id,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          commonKpiList: this.commonKpiList,
          loadingCommonKpi: this.loadingCommonKpi,
          errMsg: this.errMsg,
          isEdit: this.editMode,
          isWizard: this.wizardMode,
        }"
        v-on:input="formData = $event"
        v-on:cancel="cancelHandler"
        v-on:save="saveHandler"
        v-on:error="errorHandler"
        v-on:reload="loadKpiCommonListHandler"
      />
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import KpiSettingForm from "../../../components/performancemanagement/targetsetting/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": KpiSettingForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      pageTitle: this.$t('performancemanagement.kpisetting'),
      pageTitleValue: this.$t('performancemanagement.kpisettingdetail'),

      formData: {
        // kpiexercode: null,
        // kpiexerdesc: null,
        // startdate: null,
        // enddate: null,
        // kpiexerstatusid: null,
        // kpiexerstatus: null,
        // wfroleid: null,
        // wfrolecode: null,
        // stamp: 0,
        // userid: this.$store.getters.userId,
      },

      commonKpiList: [],
      loadingCommonKpi: false,

      errMsg: "",
      isErr: false,
      editMode: true,
      wizardMode: false,
      loading: true,
    };
  },

  methods: {

    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    saveHandler() {
      const vm = this;

      // if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
      //     return false;
      // }

      this.formData.userid = vm.$store.getters.userId;

      this.$store.dispatch('put', {url: "/kpiexercise/" + vm.id, payload: vm.formData})
      .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "kpisettinglist" });
          }
      })
      .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
      });
    },

    cancelHandler() {
      this.$router.push({ name: "kpisettinglist" });
    },

    //load kpi common list handler
    async loadKpiCommonListHandler() {
      const vm = this;
      vm.loadingCommonKpi = true;

      await this.$store.dispatch('get', {url: "/kpicommon/" + vm.id})
      .then((res) => {
        vm.commonKpiList = res.data.rec;
        vm.loadingCommonKpi = false;
      })
      .catch((err) => {
        vm.isErr = true;
        vm.errMsg = err;
        vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
      });
    },

    //load kpi exercise handler
    loadKpiExerciseHandler() {

      const vm = this;

      return this.$store.dispatch('get', {url: "/kpiexercise/" + vm.id})
      .then((res) => {

        if (res.status == 200) {
            
          vm.formData = res.data.rec[0];

          if (vm.formData.startdate) {
              vm.formData.startdate = moment(vm.formData.startdate).format('YYYY-MM-DD');
          }

          if (vm.formData.enddate) {
              vm.formData.enddate = moment(vm.formData.enddate).format('YYYY-MM-DD');
          }

          vm.formData.userid = vm.$store.getters.userId;
          // vm.loading = !vm.loading;

        } else {
          vm.isErr = !vm.isErr;
        }
      })
      .catch((err) => {
          console.log(err);
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
      });
    },
  },

  // mounted() {
  //   this.loadKpiExerciseHandler();
  // },

  async created() {
    try {
      await this.loadKpiCommonListHandler();
      await this.loadKpiExerciseHandler();
    } finally {
      this.loading = false;
    }
  }
};
</script>